var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleProducts3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 972,
    viewBox: "0 0 208 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1284_39626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 208,
    height: 972
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 972,
    transform: "matrix(-1 0 0 1 208 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1284_39626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_39626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.297 560.331C16.864 553.326 -174.121 402.157 -185.191 429.566C-211.729 495.244 -44.921 610.042 -28.5419 693.793C-16.4573 755.553 -96.3762 871.178 -139.187 927.656L-230.839 901.329C-237.637 890.134 -241.043 878.403 -237.802 867.12C-225.373 823.852 -96.0395 763.748 -235.042 554.059C-278.548 488.43 -312.538 365.568 -202.303 334.377C-132.016 314.488 -34.5994 382.551 -10.5044 417.819C24.5934 469.185 136.03 455.286 33.0554 382.464C-8.49631 353.074 -37.6809 329.28 -53.9612 301.089C-93.9752 231.805 -62.7611 183.437 -8.26405 160.938C23.8956 147.666 34.0008 125.061 39.717 92.9919C53.3739 16.3403 57.912 28.8117 62.7769 11.8756L65.4148 34.7199C65.4148 34.7199 73.4362 -24.2205 80.4436 68.8871C85.4776 135.854 7.15562 179.176 19.2743 263.248C31.4007 347.322 179.331 357.325 171.88 436.075C164.429 514.824 93.73 567.335 55.2992 560.323L55.297 560.331Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.556 566.333C-78.4611 628.265 -75.7939 472.947 -132.16 493.166C-188.526 513.384 -47.224 565.249 16.1554 696.595C74.6589 817.829 10.9091 918.818 -4.5509 947.49C-7.60642 953.156 -12.68 958.042 -19.2225 962.116L-148.322 925.032C-132.117 887.639 -109.362 826.056 -105.314 767.477C-98.9068 674.785 -120.293 640.868 -143.713 601.517C-198.904 508.784 -282.64 464.811 -219.869 409.491C-168.205 363.959 -93.1311 461.067 -57.0973 494.027C-21.0635 526.988 85.6792 507.374 97.8013 429.966C109.924 352.558 -2.29158 359.947 -26.5164 274.025C-45.4501 206.885 8.04496 174.375 35.985 146.655C63.7966 119.065 62.0294 82.0892 59.1839 58.0311C56.27 33.4302 60.0448 -25.6423 86.0961 32.2997C109.731 84.8646 106.735 101.192 97.3448 133.883C87.9543 166.574 34.1925 194.664 34.1445 230.039C34.0965 265.413 94.3765 288.109 152.763 349.685C236.045 437.526 191.269 545.161 122.556 566.333Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.297 560.331C16.864 553.326 -174.121 402.157 -185.191 429.566C-211.729 495.244 -44.921 610.042 -28.5419 693.793C-16.4573 755.553 -96.3762 871.178 -139.187 927.656L-230.839 901.329C-237.637 890.134 -241.043 878.403 -237.802 867.12C-225.373 823.852 -96.0395 763.748 -235.042 554.059C-278.548 488.43 -312.538 365.568 -202.303 334.377C-132.016 314.488 -34.5994 382.551 -10.5044 417.819C24.5934 469.185 136.03 455.286 33.0554 382.464C-8.49631 353.074 -37.6809 329.28 -53.9612 301.089C-93.9752 231.805 -62.7611 183.437 -8.26405 160.938C23.8956 147.666 34.0008 125.061 39.717 92.9919C53.3739 16.3403 57.912 28.8117 62.7769 11.8756L65.4148 34.7199C65.4148 34.7199 73.4362 -24.2205 80.4436 68.8871C85.4776 135.854 7.15562 179.176 19.2743 263.248C31.4007 347.322 179.331 357.325 171.88 436.075C164.429 514.824 93.73 567.335 55.2992 560.323L55.297 560.331Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.556 566.333C-78.4611 628.265 -75.7939 472.947 -132.16 493.166C-188.526 513.384 -47.224 565.249 16.1554 696.595C74.6589 817.829 10.9091 918.818 -4.5509 947.49C-7.60642 953.156 -12.68 958.042 -19.2225 962.116L-148.322 925.032C-132.117 887.639 -109.362 826.056 -105.314 767.477C-98.9068 674.785 -120.293 640.868 -143.713 601.517C-198.904 508.784 -282.64 464.811 -219.869 409.491C-168.205 363.959 -93.1311 461.067 -57.0973 494.027C-21.0635 526.988 85.6792 507.374 97.8013 429.966C109.924 352.558 -2.29158 359.947 -26.5164 274.025C-45.4501 206.885 8.04496 174.375 35.985 146.655C63.7966 119.065 62.0294 82.0892 59.1839 58.0311C56.27 33.4302 60.0448 -25.6423 86.0961 32.2997C109.731 84.8646 106.735 101.192 97.3448 133.883C87.9543 166.574 34.1925 194.664 34.1445 230.039C34.0965 265.413 94.3765 288.109 152.763 349.685C236.045 437.526 191.269 545.161 122.556 566.333Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.8455 963.661L-41.1596 955.815C-53.5907 942.812 -56.571 917.112 -47.0949 891.321C-35.2595 859.108 -8.48119 838.96 12.7024 846.323C33.8937 853.689 41.4745 885.775 29.6368 917.996C20.7044 942.299 3.27626 959.728 -13.8455 963.661Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.2688 896.326C-35.7076 913.856 -31.5887 931.313 -20.0514 935.317C-8.52385 939.325 6.04168 928.364 12.4805 910.834C18.9193 893.304 14.8004 875.846 3.26304 871.843C-8.26447 867.834 -22.83 878.795 -29.2765 896.323L-29.2688 896.326Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.7172 761.355C-25.2663 727.947 -6.39547 701.633 15.432 702.581C37.2595 703.529 53.7779 731.38 52.327 764.788C50.8761 798.197 32.0053 824.511 10.1778 823.563C-11.6496 822.615 -28.1681 794.764 -26.7172 761.355Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.75287 761.744C-9.30159 779.928 -0.11124 794.79 11.7769 794.942C23.6651 795.094 33.7523 780.471 34.301 762.287C34.8498 744.103 25.6594 729.241 13.7713 729.089C1.8831 728.937 -8.20416 743.56 -8.75287 761.744Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.1321 656.578C-54.4559 631.981 -58.2111 606.642 -47.5196 599.981C-36.8281 593.32 -15.7385 607.86 -0.41466 632.456C14.9091 657.053 18.6643 682.392 7.97283 689.053C-2.71869 695.714 -23.8083 681.174 -39.1321 656.578Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.9212 647.875C-17.5245 661.222 -6.07139 668.987 -0.339455 665.22C5.39249 661.453 3.23072 647.588 -5.16591 634.241C-13.5626 620.894 -25.0157 613.128 -30.7476 616.895C-36.4774 620.655 -34.3178 634.527 -25.9212 647.875Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.269486 503.161C-23.16 500.496 -42.612 507.28 -43.7118 518.307C-44.8116 529.333 -27.1488 540.426 -4.2583 543.091C18.6322 545.755 38.0842 538.971 39.184 527.945C40.2838 516.919 22.621 505.825 -0.269486 503.161Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84866 516C-14.3017 514.549 -24.8865 518.242 -25.4881 524.239C-26.0896 530.235 -16.4746 536.277 -4.01932 537.721C8.43374 539.172 19.0185 535.479 19.6201 529.482C20.2216 523.486 10.6066 517.444 -1.84866 516Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.4842 549.647C-31.5783 544.833 -49.987 547.176 -51.5973 554.892C-53.2076 562.608 -37.4103 572.767 -16.3163 577.581C4.77782 582.395 23.1865 580.052 24.7968 572.336C26.4071 564.62 10.6098 554.461 -10.4842 549.647Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.9708 561.268C-23.4476 558.644 -33.4644 559.927 -34.3364 564.119C-35.2105 568.318 -26.6175 573.842 -15.1407 576.466C-3.6638 579.09 6.35297 577.808 7.22493 573.616C8.09909 569.416 -0.493922 563.893 -11.9708 561.268Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5126 481.893C47.7385 487.99 34.2678 503.782 38.4122 517.162C42.5642 530.544 62.7645 536.446 83.5386 530.349C104.313 524.251 117.783 508.459 113.639 495.079C109.487 481.697 89.2867 475.795 68.5126 481.893Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6069 492.701C61.3068 496.023 53.9742 504.611 56.233 511.894C58.4918 519.177 69.4855 522.385 80.7833 519.071C92.0834 515.749 99.416 507.16 97.1572 499.877C94.8984 492.594 83.9047 489.386 72.6069 492.701Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9824 537.552C50.2973 541.923 36.0098 556.252 39.0625 569.559C42.1228 582.868 61.362 590.121 82.0471 585.751C102.732 581.38 117.02 567.051 113.967 553.744C110.907 540.435 91.6675 533.181 70.9824 537.552Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1722 548.358C62.9185 550.738 55.1408 558.534 56.8066 565.772C58.4702 573.017 68.9389 576.954 80.1981 574.583C91.4519 572.203 99.2296 564.407 97.5638 557.17C95.9001 549.925 85.4315 545.987 74.1722 548.358Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0977 440.984C90.9908 460.757 98.5685 479.615 113.022 483.119C127.476 486.623 143.33 473.433 148.437 453.661C153.544 433.888 145.966 415.03 131.512 411.526C117.058 408.021 101.204 421.212 96.0977 440.984Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.159 443.22C105.384 453.98 109.503 464.239 117.368 466.141C125.233 468.043 133.86 460.873 136.636 450.112C139.411 439.352 135.292 429.093 127.427 427.191C119.562 425.289 110.935 432.459 108.159 443.22Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.916 553.588C112.052 544.264 114.408 523.7 128.178 507.656C141.947 491.611 161.916 486.163 172.78 495.486C183.643 504.809 181.287 525.374 167.518 541.418C153.748 557.462 133.779 562.911 122.916 553.588Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.243 515.119C129.88 523.956 128.835 535.081 134.915 539.958C140.986 544.841 151.881 541.627 159.244 532.789C166.606 523.952 167.651 512.827 161.571 507.951C155.501 503.068 144.605 506.282 137.243 515.119Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.772 456.713C155.028 438.057 165.475 423.075 178.106 423.248C190.736 423.422 200.768 438.686 200.512 457.341C200.256 475.996 189.809 490.979 177.178 490.805C164.547 490.632 154.516 475.368 154.772 456.713Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.148 456.676C165.164 466.827 170.744 474.948 177.622 474.823C184.499 474.698 190.057 466.364 190.049 456.215C190.034 446.064 184.454 437.943 177.576 438.068C170.699 438.193 165.141 446.528 165.148 456.676Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7391 389.077C97.2037 404.76 113.251 412.342 124.579 406.006C135.906 399.669 138.234 381.822 129.772 366.131C121.307 350.448 105.26 342.865 93.9325 349.202C82.6052 355.538 80.2767 373.386 88.7391 389.077Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7834 383.347C102.391 391.877 111.119 396.004 117.282 392.559C123.444 389.115 124.707 379.398 120.108 370.869C115.501 362.339 106.772 358.212 100.609 361.657C94.4472 365.101 93.1837 374.818 97.7834 383.347Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.499 386.81C152.983 402.656 167.674 411.144 177.307 405.766C186.939 400.387 187.864 383.175 179.38 367.328C170.896 351.481 156.205 342.993 146.573 348.372C136.94 353.75 136.015 370.963 144.499 386.81Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.146 381.865C156.76 390.489 164.759 395.104 169.991 392.181C175.233 389.253 175.739 379.891 171.117 371.265C166.503 362.641 158.504 358.026 153.272 360.949C148.031 363.877 147.525 373.239 152.149 381.858L152.146 381.865Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5216 350.331C61.4379 359.073 76.949 358.464 83.1747 348.96C89.4004 339.456 83.9744 324.67 71.068 315.923C58.1517 307.181 42.6406 307.79 36.4149 317.294C30.1892 326.798 35.6152 341.584 48.5216 350.331Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.215 342.23C60.2426 346.989 68.6828 346.657 72.0697 341.485C75.4567 336.314 72.504 328.267 65.484 323.51C58.4564 318.751 50.0162 319.084 46.6293 324.255C43.2423 329.427 46.195 337.474 53.215 342.23Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.983 337.39C114.393 347.058 129.15 348.64 134.946 340.922C140.741 333.204 135.382 319.11 122.973 309.443C110.563 299.775 95.8059 298.193 90.0103 305.911C84.2146 313.629 89.5737 327.723 101.983 337.39Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.348 330.722C113.099 335.983 121.129 336.845 124.287 332.645C127.444 328.446 124.525 320.774 117.774 315.513C111.024 310.253 102.993 309.391 99.8356 313.59C96.678 317.79 99.5973 325.462 106.348 330.722Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78432 312.834C14.7006 321.576 30.2117 320.967 36.4374 311.463C42.6631 301.959 37.2371 287.173 24.3307 278.426C11.4144 269.684 -4.09673 270.293 -10.3224 279.797C-16.5481 289.301 -11.1221 304.087 1.78432 312.834Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47986 304.725C13.5075 309.484 21.9477 309.152 25.3346 303.98C28.7216 298.809 25.7688 290.762 18.7489 286.005C11.7213 281.246 3.2811 281.579 -0.105852 286.75C-3.4928 291.922 -0.540086 299.969 6.47986 304.725Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0714 298.121C61.481 307.788 76.2381 309.37 82.0338 301.652C87.8294 293.935 82.4704 279.841 70.0608 270.173C57.6512 260.506 42.8941 258.924 37.0984 266.642C31.3028 274.359 36.6618 288.453 49.0714 298.121Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4285 291.451C60.1791 296.711 68.2098 297.573 71.3674 293.374C74.525 289.174 71.6057 281.502 64.855 276.242C58.1044 270.981 50.0737 270.119 46.9161 274.319C43.7586 278.518 46.6778 286.19 53.4285 291.451Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.7245 246.376C-25.6629 259 -16.5617 267.9 -7.39612 266.256C1.76721 264.621 7.53763 253.059 5.47385 240.444C3.41227 227.82 -5.68898 218.92 -14.8545 220.563C-24.0179 222.199 -29.7883 233.76 -27.7245 246.376Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.2458 244.622C-19.1287 251.486 -14.1763 256.33 -9.18731 255.438C-4.19829 254.546 -1.06297 248.256 -2.1878 241.39C-3.30495 234.526 -8.25732 229.683 -13.2463 230.574C-18.2353 231.466 -21.3707 237.756 -20.2458 244.622Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4944 242.639C16.078 254.691 25.7471 262.077 33.0925 259.139C40.4402 256.193 42.6773 244.04 38.0958 231.98C33.5122 219.927 23.8431 212.541 16.4977 215.479C9.14997 218.426 6.91289 230.578 11.4944 242.639Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.385 239.822C19.8761 246.383 25.1399 250.403 29.1389 248.795C33.1358 247.195 34.3554 240.579 31.8643 234.018C29.3731 227.457 24.1094 223.437 20.1103 225.045C16.1112 226.653 14.8939 233.261 17.385 239.822Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.147764 172.297C-4.93335 182.471 -2.99682 193.622 4.45888 197.208C11.9222 200.797 22.0895 195.464 27.1629 185.288C32.2418 175.123 30.3075 163.964 22.8518 160.378C15.3884 156.789 5.22121 162.122 0.147764 172.297Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45377 174.914C3.69334 180.448 4.74149 186.512 8.80455 188.468C12.8599 190.422 18.3933 187.519 21.1614 181.987C23.9219 176.453 22.8737 170.389 18.8107 168.433C14.7553 166.48 9.22188 169.382 6.45377 174.914Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3668 190.004C27.4001 201.083 30.5304 211.432 37.364 213.137C44.192 214.833 52.1295 207.232 55.094 196.16C58.0608 185.081 54.9304 174.732 48.1046 173.029C41.2765 171.333 33.339 178.934 30.3745 190.006L30.3668 190.004Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0811 191.039C34.4655 197.068 36.1698 202.697 39.889 203.624C43.6005 204.549 47.92 200.409 49.5334 194.388C51.149 188.359 49.4447 182.73 45.7255 181.803C42.014 180.878 37.6945 185.017 36.0811 191.039Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.993 137.536C30.5319 146.476 32.2248 156.278 38.7833 159.433C45.3418 162.587 54.2782 157.897 58.7491 148.952C63.2103 140.012 61.5174 130.209 54.9589 127.055C48.4003 123.901 39.464 128.591 34.993 137.536Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5355 139.834C38.1082 144.7 39.0346 150.031 42.6003 151.752C46.1682 153.466 51.0346 150.92 53.462 146.054C55.8893 141.188 54.9629 135.857 51.3972 134.136C47.8293 132.422 42.9629 134.968 40.5355 139.834Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5604 153.097C58.9541 162.835 61.7036 171.937 67.7098 173.429C73.716 174.922 80.6919 168.241 83.2983 158.502C85.9046 148.764 83.1551 139.663 77.1489 138.17C71.1427 136.677 64.1668 143.359 61.5604 153.097Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5799 154.007C65.1582 159.303 66.6574 164.259 69.9273 165.074C73.1896 165.886 76.9898 162.253 78.4136 156.95C79.8353 151.654 78.3361 146.698 75.0662 145.883C71.8039 145.071 68.0037 148.703 66.5799 154.007Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7555 104.576C52.3193 114.564 57.8675 122.825 65.1406 123.03C72.4136 123.234 78.6678 115.308 79.1018 105.327C79.538 95.3392 73.9898 87.078 66.7167 86.8736C59.4437 86.6692 53.1895 94.5958 52.7555 104.576Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.753 104.422C58.514 109.85 61.532 114.346 65.4925 114.462C69.4529 114.578 72.8507 110.265 73.0919 104.829C73.3309 99.4014 70.3129 94.9059 66.3524 94.7896C62.392 94.6732 58.9942 98.9864 58.753 104.422Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.36 107.962C84.9507 117.918 91.1713 125.11 97.2612 124.028C103.351 122.946 107.001 113.997 105.418 104.044C103.827 94.0877 97.6066 86.8954 91.5168 87.9775C85.4269 89.0596 81.777 98.0082 83.36 107.962Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3178 106.745C89.1794 112.157 92.5699 116.079 95.8791 115.485C99.1959 114.894 101.176 110.024 100.314 104.612C99.4528 99.1995 96.0623 95.2779 92.7531 95.8718C89.4363 96.4634 87.4562 101.333 88.3178 106.745Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3395 64.1475C55.9033 74.1355 61.4515 82.3967 68.7246 82.6011C75.9976 82.8054 82.2518 74.8789 82.6858 64.8985C83.122 54.9105 77.5738 46.6492 70.3007 46.4449C63.0277 46.2405 56.7735 54.1671 56.3395 64.1475Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3448 63.9963C62.1058 69.4244 65.1238 73.9199 69.0843 74.0362C73.0447 74.1526 76.4425 69.8394 76.6837 64.4037C76.9227 58.9756 73.9046 54.4801 69.9442 54.3638C65.9838 54.2474 62.586 58.5606 62.3448 63.9963Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9441 67.5326C88.5524 77.4851 93.6568 84.8633 98.352 84.0116C103.047 83.16 105.553 74.4059 103.945 64.4534C102.337 54.5008 97.2325 47.1226 92.5373 47.9743C87.8421 48.826 85.3358 57.58 86.9441 67.5326Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7582 66.511C91.6275 71.9253 94.4105 75.9381 96.9676 75.4769C99.5246 75.0158 100.885 70.2503 100.016 64.836C99.1389 59.4194 96.3635 55.4089 93.8065 55.87C91.2495 56.3312 89.8889 61.0967 90.7582 66.511Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.824 901.333C-237.622 890.139 -241.043 878.403 -237.802 867.12C-225.373 823.852 -96.0392 763.747 -235.042 554.059C-274.874 493.969 -306.708 385.916 -227.191 344.159C-247.081 360.357 -256.263 383.103 -260.816 403.259C-278.758 482.69 -223.204 543.95 -176.11 606.135C-114.447 687.55 -122.772 773.447 -226.191 902.664L-230.824 901.333Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9938 440.335C80.7244 430.217 73.1311 410.806 33.0556 382.464C-8.4961 353.075 -37.6829 329.288 -53.961 301.089C-85.8294 245.91 -72.5178 203.992 -38.2396 177.852C-67.2411 214.325 -56.0755 263.242 -43.237 289.714C-15.0036 347.951 45.39 358.631 76.722 397.872C84.9902 408.226 86.2323 437.52 72.996 440.327L72.9938 440.335Z",
    fill: "#D16984"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_39626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481.153,
    height: 950.638,
    fill: "white",
    transform: "matrix(-0.961133 -0.276086 -0.276086 0.961133 316.948 74.3086)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleProducts3);
export default __webpack_public_path__ + "static/media/tentacle_products3.110b8eb01ce3bd9d0ac41dbe1e98896e.svg";
export { ForwardRef as ReactComponent };